import { Action, combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import monitoringInstance from 'shared/utils/monitoring-provider.utils';
import downloadsReducer, {
  DOWNLOADS_INITIAL_STATE as downloadsInitialState,
  type IDownloadsState,
} from './downloads-uploads/downloads';
import uploadsReducer, { initialState as uploadsInitialState, type IUploadsState } from './downloads-uploads/uploads';
import distributorsReducer, {
  IDistributorsState,
  initialState as distributorsInitialState,
} from './logistics/distributors';
import bannersReducer, { IBannersState, INITIAL_STATE as bannersInitialState } from './banners';
import customersReducer, { ICustomersState, initialState as customersInitialState } from './customers';
import exportsReducer, { IExportsState, initialState as exportsInitialState } from './exports';
import maintenanceReducer, { IMaintenanceState, INITIAL_STATE as maintenanceInitialState } from './maintenance';
import moduleNavigationReducer, {
  IModuleNavigationState,
  initialState as moduleNavigationInitialState,
} from './module-navigation';
import navigationReducer, { INavigationState, initialState as navigationState } from './navigation';
import ordersReducer, { initialState as ordersInitialState, IOrdersState } from './orders';
import platformReducer, { initialState as platformInitialState, IPlatformState } from './platform';
import pricesState, { initialState as pricesInitialState, IPricesState } from './prices';
import productsReducer, { initialState as productInitialState, IProductsState } from './products';
import promotionsReducer, { initialState as promotionsInitialState, IPromotionsState } from './promotions';
import shortcutsReducer, { initialState as shortcutsInitialState, IShortcutsState } from './shortcuts';
import staticPagesReducer, { initialState as staticPagesInitialState, IStaticPagesState } from './static-pages';
import userSessionReducer, { initialState as userSessionInitialState, IUserSessionState } from './user-session';
import usersReducer, { initialState as usersInitialState, IUsersState } from './users';
import yapeReducer, { initialState as yapeInitialState, IYapeState } from './yape';
import zonesReducer, { initialState as zonesInitialState, IZonesState } from './zones';

export interface IState {
  customers: ICustomersState;
  downloads: IDownloadsState;
  products: IProductsState;
  orders: IOrdersState;
  exports: IExportsState;
  distributors: IDistributorsState;
  navigation: INavigationState;
  userSession: IUserSessionState;
  platform: IPlatformState;
  moduleNavigation: IModuleNavigationState;
  zones: IZonesState;
  prices: IPricesState;
  banners: IBannersState;
  promotions: IPromotionsState;
  shortcuts: IShortcutsState;
  maintenance: IMaintenanceState;
  users: IUsersState;
  uploads: IUploadsState;
  staticPages: IStaticPagesState;
  yape: IYapeState;
}

export const initialState: IState = {
  customers: customersInitialState,
  downloads: downloadsInitialState,
  products: productInitialState,
  orders: ordersInitialState,
  exports: exportsInitialState,
  distributors: distributorsInitialState,
  navigation: navigationState,
  userSession: userSessionInitialState,
  platform: platformInitialState,
  moduleNavigation: moduleNavigationInitialState,
  zones: zonesInitialState,
  prices: pricesInitialState,
  banners: bannersInitialState,
  promotions: promotionsInitialState,
  shortcuts: shortcutsInitialState,
  maintenance: maintenanceInitialState,
  users: usersInitialState,
  uploads: uploadsInitialState,
  staticPages: staticPagesInitialState,
  yape: yapeInitialState,
};

export const appReducer = combineReducers({
  customers: customersReducer,
  downloads: downloadsReducer,
  products: productsReducer,
  orders: ordersReducer,
  exports: exportsReducer,
  distributors: distributorsReducer,
  navigation: navigationReducer,
  userSession: userSessionReducer,
  platform: platformReducer,
  moduleNavigation: moduleNavigationReducer,
  zones: zonesReducer,
  prices: pricesState,
  banners: bannersReducer,
  promotions: promotionsReducer,
  shortcuts: shortcutsReducer,
  maintenance: maintenanceReducer,
  users: usersReducer,
  uploads: uploadsReducer,
  staticPages: staticPagesReducer,
  yape: yapeReducer,
});

export const rootReducer = (state: IState, action: Action) => {
  if (action.type === 'store/reset') {
    storage.removeItem('persist:root');
    monitoringInstance.setUserId(null);
    return appReducer(initialState, action);
  }
  return appReducer(state, action);
};

export type TRootState = ReturnType<typeof rootReducer>;
